/**
 * Section-scoped content tabs controller.
 */
(() => {
  'use strict';

  const tagName = 'content-tabs';
  if (customElements.get(tagName)) return;

  class ContentTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.buttons = [...this.querySelectorAll('.content-tab-button')];
      this.tabs = [...this.querySelectorAll('.content-tab')];
      this.tabsContainer = this.querySelector('.content-tabs__tabs');
      this.activeButton = this.querySelector('.content-tab-button--active');
      this.activeTab = this.querySelector('.content-tab--active');
      if (!this.tabsContainer || !this.activeButton || !this.activeTab) return;

      this.isMovingAnimation = this.dataset.animation === 'moving';
      this.activeBg = this.isMovingAnimation
        ? this.querySelector('.content-tab-buttom__active-bg')
        : null;
      this.buttonListeners = new Map();
      this.buttons.forEach((button) => {
        const listener = this.handleClick.bind(this);
        this.buttonListeners.set(button, listener);
        button.addEventListener('click', listener);
      });
      this.handleResizeBound = this.scheduleLayout.bind(this);
      window.addEventListener('resize', this.handleResizeBound, { passive: true });

      if (this.activeBg) this.activeBg.style.transitionDuration = '0.4s';
      this.updateLayout();
      this.initialized = true;
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.buttonListeners.forEach((listener, button) => {
        button.removeEventListener('click', listener);
      });
      this.buttonListeners.clear();
      window.removeEventListener('resize', this.handleResizeBound);
      window.cancelAnimationFrame(this.layoutFrame);
      this.initialized = false;
    }

    handleClick(event) {
      this.activeButton = event.currentTarget;
      this.buttons.forEach((button) => {
        const isActive = button === this.activeButton;
        button.classList.toggle('content-tab-button--active', isActive);
        button.setAttribute('aria-selected', String(isActive));
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.index === this.activeButton.dataset.index;
        tab.classList.toggle('content-tab--active', isActive);
        tab.setAttribute('aria-hidden', String(!isActive));
        if (isActive) this.activeTab = tab;
      });
      this.updateLayout();
    }

    scheduleLayout() {
      if (this.layoutFrame) return;
      this.layoutFrame = window.requestAnimationFrame(() => {
        this.layoutFrame = 0;
        this.updateLayout();
      });
    }

    updateLayout() {
      if (this.activeTab) this.tabsContainer.style.height = `${this.activeTab.clientHeight}px`;
      if (!this.activeBg || !this.activeButton) return;

      this.activeBg.style.width = `${this.activeButton.getBoundingClientRect().width}px`;
      this.activeBg.style.height = `${this.activeButton.getBoundingClientRect().height}px`;
      this.activeBg.style.top = `${this.activeButton.offsetTop}px`;
      this.activeBg.style.left = `${this.activeButton.offsetLeft}px`;
    }
  }

  customElements.define(tagName, ContentTabs);
})();
